import { DomainError, TransportError } from "@econ-v1/domain";
import { ClientTransportDiscovery } from "./client-transport-discovery.js";
import { canonicalHttpsOrigin, normalizeHttpsOrigin } from "./http-origin.js";
import { HttpWsHomeNodeClient } from "./http-home-node-client.js";
/** Validate and probe an explicit LAN candidate; this never scans a subnet. */
export async function probeLanCandidate(candidate, options = {}, signal) {
    if (candidate.path !== "lan-direct") {
        throw new DomainError({ code: "invalid_request", message: "LAN probe received a non-LAN candidate" });
    }
    const origin = canonicalHttpsOrigin(candidate.address);
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), options.timeoutMs ?? 3_000);
    const abort = () => controller.abort();
    signal?.addEventListener("abort", abort, { once: true });
    try {
        const accessToken = await options.client?.accessToken?.();
        const delegation = await options.client?.delegationCredential?.();
        const headers = {};
        if (accessToken !== undefined)
            headers.authorization = `Bearer ${accessToken}`;
        if (delegation !== undefined)
            headers["x-client-device-delegation"] = delegation;
        await new ClientTransportDiscovery(options.fetch === undefined ? {} : { fetch: options.fetch }).probeLan(candidate, headers, controller.signal);
        return new HttpWsHomeNodeClient({
            ...(options.client ?? {}),
            baseUrl: origin,
            ...(options.fetch === undefined ? {} : { fetch: options.fetch }),
            transportPath: "lan-direct",
        });
    }
    catch (error) {
        if (error instanceof TransportError)
            throw error;
        throw new TransportError({ code: "offline", message: "LAN candidate is unavailable" });
    }
    finally {
        clearTimeout(timeout);
        signal?.removeEventListener("abort", abort);
    }
}
export function secureOrigin(address) {
    return normalizeHttpsOrigin(address);
}
//# sourceMappingURL=lan-probe.js.map